import type {
  IbhCatalogArticleResponseDto,
  IbhPartsResponseDto,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export const countriesWithSpecificArticleNumber = ['en-US', 'en-CA'];
export const getArticleName = (locale: string, part: IbhPartsResponseDto | IbhCatalogArticleResponseDto) =>
  (countriesWithSpecificArticleNumber.includes(locale) && part.articleNumberUsa) || part.articleNumber;
